<template>
  <div>
    <div style="display:flex;flex-direction: row;justify-content: flex-end">
      <div style="display:flex;">
        <span class="span-duty">业务代码</span>
        <a-select allowClear placeholder="请选择业务代码" style="width:140px" v-model="busicode">
          <a-select-option value="6003">6003-合同报送</a-select-option>
          <a-select-option value="6004">6004-合同终止</a-select-option>
        </a-select>
      </div>
      <div style="display:flex;margin-left:10px">
        <span class="span-duty">请求日期</span>
        <a-range-picker
          :ranges="{ Today: [moment(), moment()], 'This Month': [moment(), moment().endOf('month')] }"
          @change="dateChange"
          :format="dateFormat"
          v-model="req_date_format"
          style="width:200px"
        />
      </div>
      <a-button type="primary" style="margin-left:16px;" icon="search" @click="()=>{this.pagination.current = 1;fetch()}">查询</a-button>
    </div>
    <j-table
      :loading="loading"
      :rowKey="record=>record.joininstssn"
      :tableColumns="columns"
      :tableData="tableData"
      :tablePagination="pagination"
      v-on:onOrderbyChange="(newOrderby)=>{ orderby = newOrderby;fetch(); }"
      v-on:onPaginationChange="(newPagination)=>{ pagination = newPagination;fetch(); }"
      style="margin-top:20px"
    ></j-table>
  </div>
</template>
<script>
import JTable from "../../components/JTable";
import moment from "moment";
const columns = [
  {
    title: "请求日期",
    dataIndex: "reqdate",
    key: "reqdate",
    align: "center",
    width: 110,
    fixed: "left"
  },
  {
    title: "请求时间",
    dataIndex: "reqtime",
    key: "reqtime",
    align: "center",
    width: 150
  },
  {
    title: "业务类型",
    dataIndex: "busicode",
    key: "busicode",
    align: "center",
    width: 120,
    customRender: function(text) {
      return text == "6002"
        ? "驾校上送"
        : text == "6003"
        ? "合同报送"
        : text == "6004"
        ? "合同终止"
        : text == "6005"
        ? "学时报送"
        : text == "6006"
        ? "学时撤销"
        : text == "6007"
        ? "学时费用预支付"
        : text == "6008"
        ? "科目一费用预支付"
        : text == "6009"
        ? "合同到账状态上送"
        : text;
    }
  },
  {
    title: "合同编号",
    dataIndex: "contno",
    key: "contno",
    align: "center",
    width: 200
  },
  {
    title: "驾校名称",
    dataIndex: "drivschname",
    key: "drivschname",
    align: "center",
    width: 240
  },
  {
    title: "状态码",
    dataIndex: "respcode",
    key: "respcode",
    align: "center",
    width: 120
  },
  {
    title: "状态描述",
    dataIndex: "respdesc",
    key: "respdesc",
    align: "center",
    width: 120
  },
  {
    title: "请求流水号",
    dataIndex: "joininstssn",
    key: "joininstssn",
    align: "center",
    width: 300
  },
  {
    title: "平台日期",
    dataIndex: "platdate",
    key: "platdate",
    align: "center",
    width: 150
  }
];
export default {
  name: 'ContractFlow',
  components: {
    JTable
  },
  data() {
    return {
      drivasstid: this.$cache.session.get(this.$marco.constants.KEY_ORG_ID),
      loading: false,
      columns,
      reqdate: "",
      busicode: "",
      tableData: [],
      dateFormat: "YYYY-MM-DD",
      req_date_format: [
        moment(moment().subtract(3,'days'), "YYYY-MM-DD"),
        moment(moment(), "YYYY-MM-DD")
      ],
      start_req_date: moment().subtract(3,'days').format('YYYYMMDD'),
      end_req_date:moment().format("YYYYMMDD"),
      pagination: {
        current: 1,
        total: 0,
        pageSize: 10,
        pageSizeOptions: ["10", "20", "50"]
      },
      orderby: "drivasstid desc"
    };
  },
  created() {
    this.fetch();
  },
  methods: {
    moment,
    dateChange(dates, dateString) {
      this.start_req_date = dateString[0]
        ? moment(dateString[0]).format("YYYYMMDD")
        : "";
      this.end_req_date = dateString[1]
        ? moment(dateString[1]).format("YYYYMMDD")
        : "";
    },
    fetch() {
      const that = this;
      that.tableData = [];
      const reqData = {
        drivasstid: that.drivasstid,
        busicode: that.busicode,
        currpage: that.pagination.current,
        orderby: that.orderby,
        recnumperpage: that.pagination.pageSize,
        beginDate: that.start_req_date,
        endDate: that.end_req_date
      };
      that.$http.post(
        that.$marco.api.contractflow,
        reqData,
        data => {
          that.tableData = that.tableData.concat(data.pagelist);
          that.pagination.total = data.recnum;
          this.$log.success(JSON.stringify(that.tableData));
        },
        errorDesc => {
          this.$log.normal(JSON.stringify(errorDesc));
        },
        error => {
          this.$log.error(JSON.stringify(error));
        },
        that
      );
    }
  }
};
</script>
<style scoped>
.span-duty {
  padding: 0 11px;
  font-size: 14px;
  font-weight: normal;
  color: rgba(0, 0, 0, 0.65);
  text-align: center;
  background-color: #fafafa;
  border: 1px solid #d9d9d9;
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  border-right: 0;
  height: 32px;
  font-size: 14px;
  line-height: 1.5;
  display: flex;
  align-items: center;
}
</style>